import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
const FileIconWrapper = ({
  children
}) => {
  return /*#__PURE__*/_jsx(Flex, {
    alignItems: "center",
    blockSize: "100%",
    justifyContent: "end",
    marginInlineEnd: "200",
    children: children
  });
};
export default FileIconWrapper;